<template>
  <div>
    <div class="order-page">
      <div class="container">

        <div class="opera-btn-group" :class="{up:!showSearch}">
          <div class="opera-icon">
          <span class="pull-right opera-btn" style="margin-left: 10px">
            <perm label="goods-manager-platform-add">
              <span @click.stop="formAdd">
                   <a href="#" class="btn-circle" @click.prevent="" style="margin-right: 5px"><i
                       class="el-icon-t-plus"></i> </a>添加
              </span>
            </perm>
          </span>
            <span class="pull-left switching-icon" @click="showSearch = !showSearch">
              <i class="el-icon-arrow-up"></i>
              <span v-show="showSearch">收起筛选</span>
              <span v-show="!showSearch">展开筛选</span>
            </span>
            <!--            <span style="float: right;">-->
            <!--              <des-btn class="pull-right" perm="code-push-address-add" icon="plus" @click="formAdd">新增</des-btn>-->
            <!--            </span>-->
          </div>
          <el-form v-show="showSearch" class="advanced-query-form" onsubmit="return false">
            <el-row>
              <el-col :span="8">
                <oms-form-row :span="5" label="货品">
                  <el-select placeholder="请输入名称搜索货品" v-model="searchCondition.goodsId" filterable clearable
                             popper-class="custom-select" remote :remote-method="queryAllManageGoods">
                    <el-option :label="item.name" :value="item.goodsId" :key="item.goodsId" v-for="item in manageGoods">
                      <div>
                        <span class="pull-left">{{ item.name }}({{ item.factoryName }})</span>
                        <span class="pull-right select-other-info" v-show="item.typeId">
                      <dict :dict-group="'typeId'" :dict-key="item.typeId"></dict>
                    </span>
                      </div>
                      <div class="clearfix">
                        <span class="select-other-info" v-if="item.code">货品编号:{{ item.code }}</span>
                        <span class="ml-10 select-other-info">规格:{{ item.specifications }}</span>
                      </div>
                    </el-option>
                  </el-select>
                </oms-form-row>
              </el-col>
              <el-col :span="8">
                <oms-form-row :span="6" label="产品编码">
                  <el-input v-model="searchCondition.productCode" placeholder="请输入产品编码" :maxlength="18"></el-input>
                </oms-form-row>
              </el-col>
              <el-col :span="8">
                <oms-form-row :span="6" label="子类编码">
                  <el-input v-model="searchCondition.productSubclassCode" placeholder="请输入子类编码" :maxlength="18"></el-input>
                </oms-form-row>
              </el-col>
              <el-col :span="8">
                <oms-form-row :span="6" label="所属单位">
                  <el-select filterable placeholder="请输入名称搜所属单位" remote :remote-method="queryPermUpAllFactory"
                             :clearable="true" v-model="searchCondition.orgId"
                             popperClass="good-selects">
                    <el-option :value="org.id" :key="org.id" :label="org.name" v-for="org in allOrgList">
                      <div style="overflow: hidden">
                        <span class="pull-left" style="clear: right">{{ org.name }}</span>
                      </div>
                      <div style="overflow: hidden">
                      <span class="select-other-info pull-left">
                        <span>系统代码:</span>{{ org.manufacturerCode }}
                      </span>
                      </div>
                    </el-option>
                  </el-select>
                </oms-form-row>
              </el-col>
            </el-row>
            <el-row class="mt-10">
              <el-col :span="8">
                <oms-form-row label="" :span="3">
                  <el-button type="primary" native-type="submit" @click="searchInOrder">查询</el-button>
                  <el-button type="reset" @click="resetSearchForm">重置</el-button>
                </oms-form-row>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="order-list" style="margin-top: 20px">
          <el-row class="order-list-header">
            <el-col :span="2">产品编码</el-col>
            <el-col :span="2">所属单位</el-col>
            <el-col :span="4">货品ID/产品名称</el-col>
            <el-col :span="2">子类编码</el-col>
            <el-col :span="2">剂型</el-col>
            <el-col :span="5">剂型规格</el-col>
            <el-col :span="4">包装规格</el-col>
            <el-col :span="3">操作</el-col>
          </el-row>
          <el-row v-if="loadingData">
            <el-col :span="24">
              <oms-loading :loading="loadingData"></oms-loading>
            </el-col>
          </el-row>
          <el-row v-else-if="showTypeList.length == 0">
            <el-col :span="24">
              <div class="empty-info">
                暂无信息
              </div>
            </el-col>
          </el-row>
          <div v-else="" class="order-list-body flex-list-dom">
            <div class="order-list-item no-pointer" v-for="item in showTypeList" @click="showInfo(item)"
                 :class="['status-no',{'active':activeId===item.id}]">
              <el-row>
                <el-col :span="2">
                  {{ item.productCode }}
                </el-col>
                <el-col :span="2">
                  {{ item.orgName }}
                </el-col>
                <el-col :span="4">
                  <div class="f-grey">
                    {{ formatGoodsTypeList(item.goodsId) }}
                  </div>
                  <div>
                    {{ item.productName }}
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="vertical-center">
                    {{ item.productSubclassCode }}
                  </div>
                </el-col>
                <el-col :span="2">
                  <div>
                    {{item.productDosage}}
                  </div>
                </el-col>
                <el-col :span="5">
                  {{ item.productSpecification }}
                </el-col>
                <el-col :span="4">
                  {{ item.productPackingSpecification }}
                </el-col>
                <el-col :span="3" class="opera-btn">
                  <des-btn style="margin-right: 8px" class="is-mini" perm="goods-manager-platform-view" icon="t-search"
                           @click="formCheck(item)">查看
                  </des-btn>
                  <des-btn style="margin-right: 8px" class="is-mini" perm="goods-manager-platform-sourceCode" icon="t-codes"
                           @click="formCodeCheck(item)">编辑资源码
                  </des-btn>
                  <des-btn style="margin-right: 8px" class="is-mini" perm="goods-manager-platform-edit" icon="t-edit"
                           @click="formEdit(item)">编辑
                  </des-btn>
                  <des-btn @click="formDelete(item)" icon="delete" perm="goods-manager-platform-delete">删除</des-btn>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center" v-show="showTypeList.length && !loadingData">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="pager.currentPage"
                       :page-sizes="[20,50,100]" :page-size="20" layout="total, sizes, prev, pager, next, jumper"
                       :total="pager.count">
        </el-pagination>
      </div>
      <page-right :show="showRight" @right-close="resetRightBox" :css="{'width':'1000px'}">
        <edit-form :formItem="form" :action="action" :actionType="showRight"
                   @right-close="resetRightBox" @change="onSubmit"></edit-form>
      </page-right>
      <page-right :show="formVisible" @right-close="formClose">
        <newGoodsForm ref="goodsForm" @refresh="goodsFormRefresh" :form-item="{}" :platform="true"
                      :title="formTitle"></newGoodsForm>
      </page-right>
      <page-right :css="{'width': checkTable ? '1000px' : '700px','padding':0}" :show="formCheckVisible"
                  @right-close="formCheckClose">
        <goods-check @refreshProductRatio="refreshProductRatio" ref="goodsCheck" :platform="true" :form="checkItem"
                     :checkTable="checkTable"></goods-check>
      </page-right>
    </div>
  </div>
</template>

<script>
import {goodsManage, BaseInfo, OperatingGoods, traceRight} from '@/resources';
import editForm from '@/components/base/operating-goods/form/form.vue';
import methodsMixin from '@/mixins/methodsMixin';
import newGoodsForm from '@/components/goods/form/platformForm';
import goodsCheck from "@/components/goods/form/check";

export default {
  mixins: [methodsMixin],
  components: {
    editForm,
    newGoodsForm,
    goodsCheck
  },
  data: function () {
    return {
      doing: false,
      checkTable: false,

      checkItem: null,
      formCheckVisible: false,

      formVisible: false,
      formTitle: '新增',

      loadingData: true,
      showRight: false,
      showTypeSearch: false,
      showSearch: true,
      showTypeList: [],
      form: {},
      action: '',
      currentItem: {},
      activeStatus: 0,
      orgType: {
        0: {'title': '待审核', 'num': 0, 'auditStatus': '0'},
        1: {'title': '正常', 'num': 0, 'auditStatus': '1'},
        2: {'title': '审核不通过', 'num': 0, 'auditStatus': '2'}
      },
      filters: {
        orgId: '',
        goodsId: '',
        // auditStatus: '',
        productCode: '',
        productSubclassCode: '',
      },
      pager: {
        currentPage: 1,
        count: 0,
        pageSize: 20,
        totalPage: 1
      },
      searchCondition: {
        orgId: '',
        goodsId: '',
        // auditStatus: ''
        productCode: '',
        productSubclassCode: '',
      },
      activeId: '',
      customerList: []
    };
  },
  computed: {
    typeIdList() {
      return this.$getDict('typeId');
    }
  },
  filters: {
    formatIsUse: function (value) {
      return value ? '是' : '否';
    }
  },
  mounted() {
    this.getGoodsList();
  },
  watch: {
    filters: {
      handler() {
        this.getGoodsList();
      },
      deep: true
    }
  },
  methods: {
    formCheck(item) {
      this.checkItem = item;
      this.checkTable = false;
      this.formCheckVisible = true;
    },
    formCodeCheck(item) {
      this.checkItem = item;
      this.checkTable = true;
      this.formCheckVisible = true;
    },
    formCheckClose() {
      this.formCheckVisible = false;
      this.checkItem = null;
      this.$refs.goodsCheck.resetTable();
    },
    goodsFormRefresh() {
      this.formClose();
      this.getGoodsList();
    },
    formDelete(item) {
      if (this.doing) return;
      this.doing = true;
      this.$confirm(`是否删除"${item.productName}，子类编码为${item.productSubclassCode}"`, '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        traceRight.delete(item.id).then(() => {
          goodsManage.goodsDelete(item.productSubclassId).then(res => {
            this.getGoodsList();
            this.doing = false;
            this.$notify.success({
              message: '删除成功'
            });
          }).catch(e => {
            this.$notify.error({
              duration: 2000,
              message: e.response && e.response.data && e.response.data.msg || '解析失败'
            });
            this.doing = false;
          })
        });
      }).catch(e => {
        this.doing = false;
      });
    },
    formEdit(item) {
      if (this.doing) return;
      this.$refs.goodsForm.manageGoods = [{name: item.productName, id: item.goodsId}]
      this.$refs.goodsForm.allOrgList = [{name: item.orgName, id: item.orgId}]
      this.$refs.goodsForm.form = JSON.parse(JSON.stringify(item));
      this.formTitle = '编辑';
      this.formVisible = true;
    },
    formAdd() {
      this.formTitle = '新增';
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs.goodsForm.resetForm();
      })
    },
    formClose() {
      this.formVisible = false;
      this.$refs.goodsForm.$refs.form.clearValidate();
    },
    formatGoodsTypeList(val) {
      let goodsTypeList = this.$store.state.goodsTypeList;
      return goodsTypeList[val - 1] && goodsTypeList[val - 1].label || val;
    },
    auditPass(item) {
      this.$confirm('确认通过经营货品"' + item.name + '"的审核?', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          id: item.id,
          status: '1'
        };
        OperatingGoods.auditGoods(data).then(() => {
          this.$notify.success({
            duration: 2000,
            title: '成功',
            message: '完成审核'
          });
          this.getGoodsList(this.pager.currentPage);
        }).catch(() => {
          this.$notify.error({
            duration: 2000,
            message: '审核失败'
          });
        });
      }).catch(() => {
      });
    },
    auditNoPass(item) {
      this.$confirm('确认不通过经营货品"' + item.name + '的审核"?', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          id: item.id,
          status: '2'
        };
        OperatingGoods.auditGoods(data).then(() => {
          this.$notify.success({
            duration: 2000,
            title: '成功',
            message: '完成审核'
          });
          this.getGoodsList(this.pager.currentPage);
        }).catch(() => {
          this.$notify.error({
            duration: 2000,
            message: '审核失败'
          });
        });
      }).catch(() => {
      });
    },
    showInfo: function (item) {
      this.activeId = item.id;
    },
    deleteOperatingGoods: function (item) {
      this.$confirm('确认刪除单位"' + item.orgName + '"的经营货品"' + item.name + '"?', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        OperatingGoods.delete(item.id).then(() => {
          this.$notify.success({
            duration: 2000,
            title: '成功',
            message: '刪除经营货品"' + item.name + '"成功'
          });
          this.getGoodsList(this.pager.currentPage);
        }).catch(() => {
          this.$notify.error({
            duration: 2000,
            message: '刪除经营货品"' + item.name + '"失败'
          });
        });
      }).catch(() => {
      });
    },
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.getGoodsList(1);
    },
    handleCurrentChange(val) {
      this.getGoodsList(val);
    },
    filterCustomer: function (query) {// 过滤客户
      BaseInfo.query({keyWord: query}).then(res => {
        this.customerList = res.data.list;
      });
    },
    orgChange: function () {
      this.searchCondition.id = '';
    },
    searchInOrder: function () {// 搜索
      Object.assign(this.filters, this.searchCondition);
      this.getGoodsList(1);
    },
    resetSearchForm: function () {// 重置表单
      let temp = {
        orgId: '',
        goodsId: '',
        // auditStatus: '',
        productCode: '',
        productSubclassCode: '',
      };
      this.customerList = [];
      Object.assign(this.searchCondition, temp);
      Object.assign(this.filters, temp);
      this.getGoodsList(1);
    },
    resetRightBox: function () {
      this.showRight = false;
    },
    addType: function () {
      this.action = 'add';
      this.form = {
        name: '',
        orgId: '',
        goodsIdList: []
      };
      this.showRight = true;
    },
    searchType: function () {
      this.showTypeSearch = !this.showTypeSearch;
    },
    refreshProductRatio() {
      let params = {
        productSubclassId: this.checkItem.productSubclassId
      };
      goodsManage.allGoodsQuery(params, 1, 20).then(res => {
        // console.log(res);
        if (res.data.list.length > 0) {
          this.checkItem.packingRatio = res.data.list[0].packingRatio;
          if (this.showTypeList.find(f => f.productSubclassId === res.data.list[0].productSubclassId)) {
            this.showTypeList.find(f => f.productSubclassId === res.data.list[0].productSubclassId).packingRatio = res.data.list[0].packingRatio;
          }
        }
      });
    },
    getGoodsList: function (pageNo) {
      this.pager.currentPage = pageNo ? pageNo : 1;
      let params = Object.assign({}, {
        // pageNo: pageNo,
        // pageSize: this.pager.pageSize,
        // deleteFlag: false
      }, this.filters);
      this.loadingData = true;
      goodsManage.allGoodsQuery(params, this.pager.currentPage, this.pager.pageSize).then(res => {
        this.showTypeList = res.data.list;
        if (res.data.list.length > 0) {
          this.currentItem = Object.assign({orgGoodsDto: {}, list: []}, this.showTypeList[0]);
        } else {
          this.currentItem = Object.assign({orgGoodsDto: {id: ''}, list: []});
        }
        this.loadingData = false;
        this.pager.count = res.data.count;
      }).catch(e => {
        this.loadingData = false;
        this.pager.count = 0;
        if (e.toString().slice(-3) === '403') {
          this.$notify.error({
            duration: 2000,
            message: '您没有权限查看信息，请联系管理员。'
          });
        }
      });
    },
    onSubmit: function () {
      this.getGoodsList();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-right-part {
  box-sizing: content-box;
  width: 800px;
  padding: 30px 0;
  overflow: auto;

  .title {
    margin-left: 30px;
  }

  .order-info-part {
    padding: 0 50px;
  }

  .goods-info-left {
    width: 330px;
    margin-left: 30px;
    padding: 20px;
    float: left;
    border: 1px solid rgb(238, 238, 238);
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .goods-info-right {
    width: 210px;
    padding: 32px 20px 33px 20px;
    background-color: rgb(238, 238, 238);
    border: 1px solid rgb(238, 238, 238);
    float: left;

    .el-row {
      margin-bottom: 5px;
    }

    margin-bottom: 20px;
  }

  .min-gutter {
    .el-form-item {
      margin-bottom: 4px;
    }
  }

  .border-show {
    height: 15px;
    width: 100%;
    border-bottom: 1px solid #777777;
    opacity: 0.2;
    margin-bottom: 10px;
  }

}

.exceptionPosition {
  /*margin-left: 40px;*/
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.table {
  .order-list-item {
    color: #999;
    line-height: 20px;
  }

  border-collapse: separate;
  border-spacing: 0;

  > tbody > tr > td {
    border-top: 1px solid #eee;
  }

}

.empty-position {
  width: 150px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.w90 {
  width: 90px;
}

.page-right-part {
  width: 750px;
  padding: 0 0 30px 0;
}

.base-pic-item {
  border: 1px solid #eee;
  position: relative;
  cursor: pointer;
  width: 180px;
  margin: 5px;
  padding: 10px;
  font-size: 12px;

  img {
    width: 180px;
    height: 180px;
    display: block;
    background: #ccc;

  }

}

.margin-left {
  margin-left: 15px;
}

.margin-left-right {
  margin-left: 38px;
  margin-right: 38px;
}

.power-style-part {
  margin: 12px 0;
  background-color: rgb(238, 238, 238);
  padding: 12px 10px 10px 10px;
}

.el-form .el-checkbox__label {
  font-size: 12px;
  padding-left: 5px;
}

.el-form .el-checkbox__inner {
  width: 14px;
  height: 14px;
}

.margin-bottom {
  margin-bottom: 2px !important;
}

.border-show {
  height: 20px;
  border-bottom: 1px solid #777777;
  opacity: 0.2;
  margin-left: 40px;
  margin-right: 40px;
  margin-bottom: 20px;
}

.right-title {
  background-color: #b1b1b1;
  height: 30px;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 20px;
  padding-top: 10px;

}

.content-part {
  position: absolute;
  top: 40px;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;

  .content-left {
    width: 120px;
    height: 100%;
    float: left;
    background-color: rgb(238, 238, 238);

    .list-style {
      cursor: pointer;
      padding: 8px 5px 8px 5px;

      &:hover {
        background-color: #ffffff;
      }
    }

    .click-it {
      background-color: #ffffff;
    }
  }

  .content-right {
    width: 510px;
    height: 100%;
    float: left;
    padding-top: 10px;

    .hide-content {
      display: none;
    }

    .show-content {
      display: block;
    }
  }

  .min-gutter {
    .el-form-item {
      margin-bottom: 4px;
    }

    .el-form-item__label {
      font-size: 12px
    }
  }
}

.locked {
  border-left: 5px solid #fa0;
  text-indent: -5px;
}

.d-table-col-wrap {
  overflow: auto;
}

.list-item {
  padding-right: 10px;
}
</style>
